<div class="flex-row margin-tb-10">
  <div class="flex-1"></div>

  <mat-accordion class="headers-align flex-3" multi>
    <mat-expansion-panel [expanded]="true">
      @if (loadingApplication) {
        <mat-progress-bar style="height: 5px;" mode="indeterminate"></mat-progress-bar>
      }

      <mat-expansion-panel-header>
        <mat-panel-title>
          Demographics
        </mat-panel-title>
        <mat-panel-description>
          <span class="{{getDemographicReviewStatus}}">{{getDemographicReviewStatus}}</span>
          <mat-icon>person</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <hr>

        @if (!loadingApplication) {
          <div class="margin-lr-20">
            <h2>
              {{application?.userDemographicModel?.firstName}} {{application?.userDemographicModel?.lastName}}
            </h2>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Email</div>
              <div class="flex-3">{{application?.userDemographicModel?.emailAddress}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Address</div>
              <div class="flex-3">{{application?.userDemographicModel?.address}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">City</div>
              <div class="flex-3">{{application?.userDemographicModel?.city}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">State</div>
              <div class="flex-3">{{application?.userDemographicModel?.state}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Zip Code</div>
              <div class="flex-3">{{application?.userDemographicModel?.zipCode}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Primary Phone Number</div>
              <div class="flex-3">{{application?.userDemographicModel?.primaryPhoneNumber}}</div>
            </div>
            <div class="flex-row padding-5">
              <div class="flex-1 bold-text">Secondary Phone Number</div>
              <div class="flex-3">{{application?.userDemographicModel?.secondaryPhoneNumber}}</div>
            </div>
          </div>
        }

        <div class="padding-20 flex-row float-right">
          <mat-checkbox [(ngModel)]="demographicsValid">Are these demographics acceptable?</mat-checkbox>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Financial Information
          </mat-panel-title>
          <mat-panel-description>
            <span class="{{getFinancialsReviewStatus}}">{{getFinancialsReviewStatus}}</span>
            <mat-icon>attach_file</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <hr>

          <div class="flex-row margin-lr-20">
            <div class="flex-1">
              <h2>{{application?.userDemographicModel?.firstName}} {{application?.userDemographicModel?.lastName}}'s Finances</h2>

              <div class="flex-row padding-5 max-width-600">
                <div class="flex-1 bold-text">Salary</div>
                <div class="flex-1">${{application?.salary}} @if (getSalaryType != undefined && getSalaryType.length > 0) {
                  <span>({{getSalaryType}})</span>
                }</div>
              </div>

              <div class="flex-row padding-5 max-width-600">
                <div class="flex-1 bold-text">Federal Tax Filing Type</div>
                <div class="flex-1">{{getFilingType}}</div>
              </div>

              <div class="flex-row padding-5 max-width-600">
                <div class="flex-1 bold-text">Number of Dependents</div>
                <div class="flex-1">{{application?.numberOfDependents}}</div>
              </div>

              <div class="flex-row padding-5 padding-bottom-20 max-width-600">
                <div class="flex-1 bold-text">Awarded Discount</div>
                <div class="flex-1">{{application?.incomeContribution}}%</div>
              </div>

              @for (financialDocument of application?.financialDocumentModels; track financialDocument) {
                <div class="flex-row align-items-center">
                  <button mat-icon-button
                    aria-label="Download this document"
                    matTooltip="Download file"
                    (click)="downloadFile(financialDocument)">
                    <mat-icon>file_download</mat-icon>
                  </button>
                  {{financialDocument?.name}}
                </div>
              }
            </div>
          </div>

          <div class="padding-20 flex-row float-right">
            <mat-checkbox class="margin-lr-10" [(ngModel)]="financialsValid">Is the financial data valid?</mat-checkbox>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Notes
            </mat-panel-title>
            <mat-panel-description>
              <span></span>
              <mat-icon>comment_outline</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <hr>

            <div class="text-box-width flex-row">
              <mat-form-field class="flex-3">
                <mat-label>Leave a note</mat-label>
                <textarea matInput placeholder="This needs work because..." [(ngModel)]="note"></textarea>
              </mat-form-field>

              <div class="flex-1 margin-20">
                <button mat-stroked-button
                  color="primary"
                  aria-label="Save comment"
                  (click)="postNote()">
                  Save
                </button>
              </div>
            </div>

            @if (loadingNotes) {
              <mat-progress-bar style="height: 4px;" mode="indeterminate"></mat-progress-bar>
            }

            <div class="scrollable-table">
              <table mat-table [dataSource]="applicationNoteDataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef class="padding-5">Note</th>
                  <td mat-cell *matCellDef="let element" class="cell-min-width padding-5">{{element?.note}}</td>
                </ng-container>

                <ng-container matColumnDef="employee">
                  <th mat-header-cell *matHeaderCellDef class="padding-5">Employee</th>
                  <td mat-cell *matCellDef="let element" class="cell-min-width padding-5">{{element.employeeModel?.emailAddress ?? "N/A"}}</td>
                </ng-container>

                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef class="padding-5">Date</th>
                  <td mat-cell *matCellDef="let element" class="cell-min-width padding-5">{{element?.createDateUTC | date:'medium'}}</td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button
                      (click)="deleteNote(element?.applicationNoteId)"
                      matTooltip="Delete note"
                      class="span-form margin-tb-10">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="applicationNoteColumnHeaders"></tr>
                <tr mat-row *matRowDef="let row; columns: applicationNoteColumnHeaders;"></tr>

                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No notes found.</td>
                </tr>
              </table>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Their Story
              </mat-panel-title>
              <mat-panel-description>
                <span></span>
                <mat-icon>bookmark</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <hr>

              <div class="text-box-width flex-row">
                <mat-form-field class="flex-3">
                  <textarea matInput [(ngModel)]="shareYourStory" style="height: 150px" readonly></textarea>
                </mat-form-field>
              </div>
            </mat-expansion-panel>

            <div class="margin-tb-10 margin-top-30">
              @if (saving) {
                <mat-progress-bar style="height: 5px;" mode="indeterminate"></mat-progress-bar>
              }
            </div>

            <div class="margin-tb-10 margin-top-30">
              @if (!saving) {
                <button
                  mat-raised-button
                  color="primary"
                  class="button-full-width margin-top-30"
                  (click)="onNeedsWorkApplication()">
                  Needs Work
                </button>
              }
            </div>

            <div class="margin-tb-10">
              @if (!saving) {
                <button
                  mat-raised-button
                  color="primary"
                  class="button-full-width margin-top-30"
                  (click)="onDenyApplication()">
                  Deny
                </button>
              }
            </div>

            <div class="button-full-width">
              @if (!saving) {
                <button
                  [disabled]="!demographicsValid || !financialsValid"
                  mat-raised-button
                  color="primary"
                  class="button-full-width"
                  (click)="onApproveApplication()">
                  Approve
                </button>
              }
            </div>
          </mat-accordion>

          <div class="flex-1 padding-30">
            <button mat-icon-button
              matTooltip="Return to applications"
              (click)="goBack()"
              class="float-right"
              aria-label="Return to applications">
              <mat-icon>arrow_back</mat-icon>
            </button>
          </div>
        </div>
        